/**
 * Share button displayed on the article page.
 * Since it's really tied to Bottom bar, logic about showing/hiding button is done in NavbarScroll.js
 */
import MediaQueries from "../utils/MediaQueries";
import BrowserDetect from "../utils/BrowserDetect";
import _ from "lodash";

const $share = $(".share"),
      trigger = "[data-share-menu]",
      openingShareClass = "share--opening",
      openShareClass = "share--open",
      visibleShareClass = "share--visible",
      pushToFrontShareClass = "share--push-to-front";

function getOpenGraphData(property) {
    const metadata = document.querySelector(`meta[property='${property}']`);

    return metadata ? metadata.getAttribute('content') : "";
}

function handleScroll(articlePage) {
    // We want to handle scroll for sharing button only on mobile / tablet
    if(MediaQueries.isLgUp()) {
        return;
    }

    const scrollY = $(window).scrollTop();
    // Hide share button when scroll reaches article page's bottom
    if(scrollY >= articlePage.height() - articlePage.position().top) {
        $share.removeClass("share--visible");
    } else if(scrollY > 300 && scrollY <= articlePage.height() - articlePage.position().top) {
        $share.addClass("share--visible");
    }
}

function initScroll(articlePage) {
    const throttledHandleScroll = () => requestAnimationFrame(() => handleScroll(articlePage));
    $(window).scroll( _.throttle(throttledHandleScroll, 100));
}

function initNativeShare() {
    $(trigger).click(function(e) {
        e.preventDefault();
        e.stopPropagation();

        navigator.share({
            title: getOpenGraphData("og:title"),
            text: getOpenGraphData("og:description"),
            url: getOpenGraphData("og:url"),
        })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));

        return false;
    });
}

function initSpecialShare() {

    const duration = 150,
        longDuration = 350;

    $(trigger).click(function(e) {

        const shouldPreventEvent = $(this).attr('href') === '#';

        if(shouldPreventEvent) {
            e.preventDefault();
        }

        // On desktop, sticky share button is hidden by default, so we display only when overlay is here
        if(MediaQueries.isLgUp()) {
            $share.toggleClass("hide-for-large-up");
            $share.toggleClass(visibleShareClass);
        }
        // Change share button icon to close button + avoid scroll on the whole body
        if ($share.hasClass(openingShareClass)) {
            $share.removeClass(openShareClass);
            $("body, html").removeClass("u-disable-scroll");
            window.setTimeout(function () {
                $share.removeClass(pushToFrontShareClass);
            }, longDuration);
            window.setTimeout(function () {
                $share.removeClass(openingShareClass);
            }, duration);
        }
        // Reset share button icon
        else {
            $share.addClass(openingShareClass);
            $share.addClass(pushToFrontShareClass);
            $("body, html").addClass("u-disable-scroll");
            window.setTimeout(function () {
                $share.addClass(openShareClass);
                $share.addClass(visibleShareClass);
            }, duration);
        }

        if(shouldPreventEvent) {
            return false;
        }
    });
}

export default {

    init(articlePage) {
        if(articlePage) {
            initScroll($("." + articlePage));
        }

        const iOsShareButton = $('.share__button__ios-share'),
            androidShareButton = $('.share__button__android-share');

        if(BrowserDetect.isIOS()) {
            iOsShareButton.removeClass("u-hide");
        } else {
            androidShareButton.removeClass("u-hide");
        }

        // If browser support native share, enable it, otherwise display a custom share interface
        if (navigator.share) {
            initNativeShare();
        } else {
            initSpecialShare();
        }
    }
}



// WEBPACK FOOTER //
// ./js/social/ShareButton.js